import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricPaidClicks extends MetricBase {
    constructor() {
        super({
            field: "metric_paid_clicks",
            defaultVisibility: false,
            unit: EmptyUnit,
            chartName: i18n.t("metrics.tripadvisor.paidClicks.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.paidClicks.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.paidClicks.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricPaidClicks;